import {Pipe, PipeTransform} from '@angular/core';
import {AdminService} from "../services/admin.service";

@Pipe({
    name: 'menupermission'
})

export class MenupermissionPipe implements PipeTransform {
    params = '';
    transform(value: any, args?: any): any {
        return (this.params == 'write') ? 'block' : 'none';
    }

}




// WEBPACK FOOTER //
// ./src/app/custompipes/menupermission.pipe.ts